/* eslint quotes: "off" */
const en = {
  common: {
    ok: "OK!",
    oops: "Oops!",
    cancel: "Cancel",
    back: "Back",
    email: "Email",
    name: "Name",
    done: "Done",
    optional: "Optional",
    next: "Next",
    apply: "Apply",
    add: "Add",
    edit: "Edit",
    save: "Save",
    view: "View",
    error: "Error",
    loading: "Loading...",
    submit: "Submit",
    confirm: "Confirm",
    discardChanges: "Discard changes",
    skip: "Skip",
    yes: "Yes",
    no: "No",
    you: "You",
    openCruisenApp: "Open Cruisen",
  },
  forceUpdate: {
    title: "Update Required",
    body: "A new version of the app is available. Please update to continue using the app.",
    updateNow: "Update Now",
  },
  screenList: {
    readyForLaunch: "Screen List",
    exciting: "(tap a button to navigate)",
  },
  loginScreen: {
    sentMagicLink: "You've got mail!",
    inviteText: "has invited you to their cruise! Enter your email to join.",
    clickTheLink:
      "We’ve sent you a magic login link. Tap the button in your email to automatically login. It may take a few minutes to arrive.",
    confirmationCodeInEmail:
      "Please enter the confirmation code you received at your email address. It may take a few minutes to arrive.",
    openMailApp: "Open mail app",
    resendEmail: "Resend email",
    openEmailTitle: "Login link sent",
    openEmailError: "Unable to open default email client.",
    resentLoginEmail: "We've sent you another login link!",
    resending: "Resending...",
    loggingIn: "Logging in...",
    enterEmailError: "Please, enter your email again",
    accountRemoval: "Account removal",
    accountRemovalMessage:
      "We've received the request to remove your account. It may take up to 5 business days for your data to be removed from the system. Thank you for being a Cruisen customer.",
    enterConfirmationCode: "Enter confirmation code",
    travelAdvisor: "I am a travel advisor",
    travelAdvisorInfo: "Travel advisor information",
    travelAdvisorInfoDescription:
      "To register as a travel advisor please navigate to Cruisen.com and hit “Get Started” from a desktop computer.",
    backToLogin: "Back to login",
  },
  ahoyScreen: {
    ahoy: "Ahoy!",
    welcomeToCruisen: "Welcome to Cruisen, the easiest way to book a cruise – period.",
  },
  onboardingScreen: {
    next: "Next",
    getCruising: "Get cruising!",
    createTrip: {
      title: "Create your ideal trip",
      description:
        "Simply set the region you'd like to cruise from, pick a destination or two, and tell us when you'd like to go on your cruise.",
    },
    rallyCrew: {
      title: "Rally your crew",
      desciption:
        "Invite your friends, family, and first mates. Add and arrange everyone into their respective rooms for the trip.",
    },
    bookCruise: {
      title: "Book the perfect cruise",
      description:
        "Browse an amazing selection of cruises, tailored perfectly to fit you and your crew.",
    },
    navigator: {
      title: "Need some assistance?",
      description:
        "Ask our AI powered Navigator for advice about your trip, or even get an advisor for personalized help.",
    },
    loyaltyProgram: {
      title: "Earn points",
      description:
        "Get rewarded for creating a trip, inviting your friends, and booking with Cruisen.",
    },
  },
  registerScreen: {
    introduceYourself: "Introduce yourself",
    addPhoto: "Add a photo",
    changePhoto: "Change photo",
    basicDetails: "Basic details",
    firstName: "First name*",
    lastName: "Last name*",
    ageGroup: "Age group*",
    phoneNumber: "Phone number*",
    referralCode: "Referral code",
    emailAddress: "Email address",
    setSail: "Set sail",
    chooseOption: "Choose an option",
    takePhoto: "Take a photo",
    chooseFromLibrary: "Choose from library",
    errors: {
      failedToCreateUser:
        "Oops! There was an error saving your profile. Please check your internet connection and try again!",
      failedToUploadAvatar:
        "Oops! There was an error uploading your avatar. Please check your internet connection and try again, or select a different photo.",
      phoneNumberTitle: "Invalid Phone Number",
      phoneNumberDescription: "Please enter a valid phone number, such as (123) 456-7890.",
    },
    termsAgreement: "By signing up, you agree to Cruisen's ",
    termsAndConditions: "Terms and Conditions",
    acceptableUsePolicy: "Acceptable Use Policy",
    privacyPolicy: "Privacy Policy",
    commaSpace: ", ",
    and: "and ",
  },
  tripCreation: {
    title: "Create a trip",
    nameYourTrip: "Name your trip*",
    sailingFrom: "Sailing from",
    sailingTo: "Sailing to",
    travelDates: "Departure months*",
    createTrip: "Create trip",
    cruisesCount: "Cruises found: %{cruisesCount}",
    advisorWillBeAdded: "%{advisorName} will be added to this trip as your travel advisor.",
    errors: {
      tripNameTitle: "Trip Name Too Long",
      tripNameDescription: "Trip name cannot exceed 25 characters",
    },
  },
  tripOverview: {
    departing: "Depart %{locations}",
    to: "Sail to %{locations}",
    locations: "%{amount} locations",
    cruises: "cruises",
    cruise: "cruise",
    showAll: "Show all",
    crew: "Rooms",
    invite: "Invite",
    assignedAgent: "Assigned trip agent:",
    tripAdvisor: "Trip advisor",
    tags: {
      agentPick: "Advisor pick",
      priceDrop: "Price drop",
    },
    searchingCruises: "Searching cruises...",
    inviteTextMessage:
      "%{invitingUser} has invited you to join the “%{tripName}” trip on the Cruisen app",
    addRoom: "Add room",
    deleteRoom: "Delete room",
    bookRoom: "Book room",
    noCruisesFound: "No cruises found",
    emptyCruisesListMessage:
      "We couldn't find any cruises for these dates at this port. Try updating your search.",
    changeSearchCriteria: "Please, change your search criteria",
    changeDates: "Change dates",
    changePort: "Change port",
    roomOptions: "Room options",
    addGuest: "Add a guest",
    addProfileGuest: "Add profile as a guest",
    pickProfile: "Pick profile",
    changeName: "Change name",
    guestOptions: "Guest options",
    unassigned: "Unassigned",
    unassignedActionText: "Join a room to be included in booking",
    joinRoom: "Join room",
    bringEveryone: "Organize your crew.",
    showMorePorts: "Show %{amount} more ports",
    sortBy: "Sort by",
    filters: "Filters",
    incompleteProfile: "Incomplete profile",
    unclaimedProfile: "Unclaimed profile",
    reviewQuote: "Review quote",
    quoteDetails: "Quote details",
    noMessagesFound: "No messages found",
    resetFilters: "Reset filters",
    tabTitles: {
      navigator: "Navigator",
      cruises: "Cruises",
      crew: "Rooms",
    },
    sortingLabels: {
      date: "Date",
      durationShortToLong: "Duration (shortest to longest)",
      durationLongToShort: "Duration (longest to shortest)",
      mostLiked: "Most liked",
      priceByLowest: "Price (low to high)",
      priceByHighest: "Price (high to low)",
    },
    emptyCruiseList: {
      title: "Ready to set sail?",
      description: "Edit the trip details to unlock the full itinerary.",
      button: "Edit trip details",
    },
  },
  cruiseFilteringModal: {
    reset: "Reset",
    ports: "Ports",
    filterBy: "Filter By",
    noFiltersAvailable: "No filters available",
    price: "Price",
    dates: "Dates",
    availability: "Cabin Availability",
    tagsBoxTitle: "Tags",
    tags: {
      agentPick: {
        name: "Agent pick",
        label: "Advisor pick",
      },
      priceDrop: {
        name: "Price drop",
        label: "Price drop",
      },
    },
    duration: "Duration",
    ships: "Ships",
    shipLaunchYear: "Ship launch year",
    cruiseLines: "Cruise Lines",
    matchingCruisesCount: "%{amount} matching cruises",
    done: "Done",
    days: "%{amount} Days",
  },
  addGuestModal: {
    pickProfile: "Pick profile",
    requiredFirstName: "First name*",
    requiredLastName: "Last name*",
    requiredAgeGroup: "Age group*",
    requiredDateOfBirth: "Date of birth*",
    email: "Email",
    phoneNumber: "Phone number (optional)",
    phoneNumberNote:
      "By adding a phone number, I authorize Cruisen to text this guest on my behalf.",
    addGuest: "Add guest",
    fillFirstAndLastNameError: "You need to fill guest age group, first and last name",
  },
  editGuestModal: {
    editGuest: "Edit guest",
  },
  guestOptionsModal: {
    fixDob: "Non-adult guests must provide their date of birth. Please update this guest.",
    editDetails: "Edit details",
    removeGuest: "Remove guest",
  },
  changeRoomDetailsModal: {
    shortTitle: "Rename",
    title: "Change room details",
    roomNamePlaceholder: "Room name",
    submitButton: "Update details",
    fillRoomName: "You need to fill room name",
    errors: {
      roomName: "Room name cannot exceed 20 characters",
    },
  },
  addRoomModal: {
    title: "Add room",
    requiredRoomName: "Room name*",
    cabinTypePreference: "Cabin type preference",
    cabinTypePlaceholder: "No preference",
    submitButton: "Add room",
  },
  selectCruiseModal: {
    title: "Select cruise",
    description:
      "Selecting this cruise will set it as the choice for your entire trip, visible to all participants.",
    checkbox: "Don't show this modal again",
    cancel: "Cancel",
    select: "Select",
  },
  deleteRoomModal: {
    title: "Delete room",
    warning: "Deleting room will move all guests to unassigned",
    submitButton: "Confirm",
  },
  cruiseSuggestionCard: {
    perPerson: "/pp",
    upperCaseDeal: "DEAL",
    wasOn: "was %{price}",
    for: "for",
    noCabinsAvailable: "No cabins available",
    view: "View",
    tags: {
      lastOne: "Last one",
    },
  },
  bookedCruiseCard: {
    from: "From",
    to: "To",
    book: "Book",
    view: "View",
    ports: "%{amount} ports",
    daysAndNights: "%{daysAmount} days, %{nightsAmount} nights",
    viewItinerary: "View itinerary",
  },
  roomCard: {
    deck: "Deck",
    cabin: "Cabin",
    leaveRoom: "Leave room",
    join: "Join",
    addGuest: "Add guest",
    changeName: "Change name",
    genericBookedRoom: "Guaranteed %{cabinType} cabin",
    noRoomStatus: "Open",
  },
  monthPicker: {
    dates: "Departure months",
    loadingDates: "Destination months are surfing the waves. Hold on!",
    datesUnavailable: "Some of the selected dates are unavailable",
    clearUnavailableDates: "Clear unavailable months",
  },
  portPicker: {
    searchOrigin: "Search an origin",
    searchDestination: "Search a destination",
    originPorts: "Origin ports",
    destinationPorts: "Destination ports",
    portsLoading: "Ports data is surfing the waves. Hold on!",
    noResults: "No results",
    tryEditingYourSearch: "Try editing your search",
    pickDeparturePort: "For destination ports, pick at least one departure port first!",
  },
  cruiseDatePicker: {
    startDate: "Start date",
    endDate: "End date",
    clear: "Clear",
  },
  errorAlert: {
    default: {
      title: "Oops!",
    },
    email: {
      title: "Invalid email address",
      content: "Please try again.",
    },
  },
  errorScreen: {
    title: "Something went wrong!",
    friendlySubtitle:
      "This is the screen that your users will see in production when an error is thrown. You'll want to customize this message (located in `app/i18n/en.ts`) and probably the layout as well (`app/screens/ErrorScreen`). If you want to remove this entirely, check `app/app.tsx` for the <ErrorBoundary> component.",
    reset: "RESET APP",
  },
  inviteModal: {
    heading: "Bring everyone",
    contentDisabledLoyalty: "Simply send an invite to add others to your trip!",
    content:
      "Simply send an invite to add others to your trip! Earn %{tokenAmount} Cruisen Points for each invitation, up to %{invitationBonusLimit} people.",
    button: "Send invite",
    later: "Later",
  },
  globalMenu: {
    paymentMethod: "Payment method",
    trips: "Trips",
    thirdOption: "Third option",
    logOut: "Log out",
    accountSettings: "Account settings",
    deleteAccount: {
      title: "Delete account",
      warning:
        "Are you sure you want to delete your account? This will permanently remove all personal information and account data and cannot be undone.",
    },
  },
  globalMenuScreen: {
    viewProfile: "View profile",
    trips: "Trips",
    loyaltyTokens: "Cruisen Points",
    allProfiles: "Traveler profiles",
    myCards: "My cards",
    developerScreen: "Developer screen",
    inviteToTrip: "Invite to trip",
  },
  advisorDetailsModal: {
    advisorDetails: "Advisor details",
    shortBio: "Short bio",
    favoriteTravelDestination: "Favorite travel destination",
    bestTravelAdvice: "Best travel advice",
    agency: "Agency",
    viewTermsAndConditions: "View Terms & Conditions",
  },
  accountScreen: {
    title: "You",
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    phoneNumber: "Phone number",
    pirateName: "Pirate name 🏴‍☠️",
    random: "Random",
    manageAccount: "Manage account",
    logout: "Log out",
    deleteAccount: "Delete account",
    unsavedTitle: "Unsaved changes",
    unsavedMessage: "Are you sure you want to discard all account changes?",
  },
  invitationScreen: {
    title: "has invited you to their trip!",
    joinTrip: "Join trip",
    declineInvite: "Decline invite",
    inviteMessage: "You've been invited to Cruisen, sign up now!",
    signUp: "Sign up",
    yourAdvisor: "Your advisor",
    joinTripDescription: `Your advisor invited you on a trip "%{tripName}", accept the invitation to start chatting.`,
    newAdvisor: "New advisor",
    newAdvisorMessage:
      "%{advisorName} will replace your current advisor and become your dedicated travel advisor for this and all future trips.",
    email: "Email",
    phone: "Phone",
    bestTravelAdvice: "Best travel advice",
    accept: "Accept",
    iAgree: "I have read and agree to the advisor's",
    termsAndConditions: "Terms & Conditions",
  },
  tripListScreen: {
    title: "Trips",
    guests: "%{amount} guests",
    noCruiseSelected: "No cruise selected",
    newTrip: "New trip",
  },
  cardsScreen: {
    title: "My cards",
    addCard: "Add card",
    noCards: "No cards yet",
  },
  cruiseDetailsScreen: {
    decks: "Decks",
    trip: "The trip",
    ship: "The ship",
    day: "Day %{day} · %{date}",
    viewFullTrip: "View full trip",
    perPerson: "/pp",
    select: "Select",
    unselect: "Unselect",
    showMore: "Show more",
    whatsIncluded: "What's included",
    cabins: "Cabins",
    noCabinsAvailable: "No cabins available",
    startingFrom: "Starting from",
    estimatedAt: "Estimated at",
    showDetails: "Show details",
    cabinTypeDetails: "Cabin type details",
    cabinImageUnavailable: "Cabin image unavailable",
    setPreferredCruise: "Select cruise",
    unsetPreferredCruise: "Selected",
    preferredCruiseDetails: "Select this cruise to be the one you and your guests intend to book.",
    errors: {
      failedToLoad:
        "Oops! There was an error loading cruise details. Please check your internet connection and try again!",
    },
  },
  roomLayout: {
    adult: "adult",
    adults: "adults",
    child: "child",
    children: "children",
  },
  tripDetails: {
    anytime: "Anytime",
    anywhere: "Anywhere",
    anyport: "Any port",
    months: "months",
    anyportIn: "Any port in %{group}",
    anyportInLocations: "Any port in %{amount} locations",
    anyportFrom: "Any port from %{group}",
    anyportFromLocations: "Any port from %{amount} locations",
    locations: "%{amount} locations",
  },
  imageError: {
    generic: "Image is unavailable",
    cabin: "Cabin image is unavailable",
    cruise: "Cruise image is unavailable",
  },
  navigatorSystemMessageComponents: {
    createTripWelcomeOne:
      "Hi, %{userFirstName} 👋 Welcome to Cruisen! I'm Navigator, your dedicated AI assistant. I’m here to guide you during your cruise booking journey.",
    createTripWelcomeTwo:
      'The first step to booking your dream cruise is to add your rooms and guests on the "Rooms" tab.',
    createTripWelcomeThree:
      'If you need any advice, don\'t hesitate to "Ask Navigator", or you can try "Get Advisor" for more personalized assistance.',
    joinTripWelcomeOne:
      "Hello %{userFirstName}! Welcome aboard the adventure of a lifetime. I'm Navigator, your dedicated AI assistant. I’m here to guide you during your cruise booking journey.",
    joinTripWelcomeTwo:
      'If you need any advice, don\'t hesitate to "Ask AI", or you can try "Get Advisor" for more personalized assistance.',
    viewTutorial: "How to book a cruise",
    cruiseBooked: "View booked cruise",
    cruiseResultsReady: "Dive into the cruise results 🏊‍♂️",
    cruiseBookedDates: "Sailing dates: ",
    viewCruise: "View cruise",
    viewCruises: "View cruises",
    viewRooms: "View rooms",
    addGuests: "Add guests",
    exploreMore: "Explore more",
    userBookedCabin: "%{authorName} booked a cabin for %{roomName}! 🎉",
    bookNearby: "Book nearby",
    departingFrom: "Departing from %{port}",
    cabinNumber: "Cabin #%{cabinNo}",
    preferredCruiseSet: "%{authorName} selected this cruise.",
    sailingTo: "Sailing to: ",
    departing: "Departing: ",
    dates: "Departure months: ",
    anyPort: "Anywhere",
    multiplePorts: "Multiple selected",
    recommendedDeck: "Check cabins at %{deckName} for your crew",
    navigatorCruiseRecommendation: "%{cruiseSailingName} cruise sailing from %{date}.",
    savedCabin: {
      singleCabin: "%{authorName} saved Cabin %{cabinNo} for %{roomName}",
      multipleCabins: "%{authorName} saved %{cabinAmount} cabins:",
      cabinSaved: "Cabin %{cabinNo} for %{roomName}",
    },
    paymentRequest: {
      title: "New quote",
      deckAndCabin: "Deck · Cabin",
      billDate: "Bill date",
      depositAmount: "Deposit amount",
      totalAmount: "Total amount:",
      amount: "Amount",
      totalDueDate: "Final due date",
      cabinFare: "Cabin fare",
      taxesAndFees: "Taxes & fees",
      reviewQuote: "Review",
      open: "Open",
      declineQuote: "Decline quote",
      paymentRequestNotSupported:
        "Payment request is not supported in that app version, please update Cruisen app",
    },
    userApprovedPaymentRequest: {
      title: "Quote “%{quoteName}” was approved",
      message: ' approved payment for the quote "%{quoteName}" for the trip "%{tripName}".',
      button: "View details",
    },
  },
  navigator: {
    name: "Navigator",
    askAQuestion: "Request assistance",
    messageCrew: "Message your group",
    message: "Chat",
    askAI: "Ask AI",
    askNavigator: "Ask Navigator a question",
    contactAdvisor: "Get Advisor",
    delayInfo: "Our live chat hours are Monday-Friday 10am-6pm EST, responses may be delayed.",
    getHelp: {
      button: "Contact Cruisen",
      title: "Contact Advisor",
      emailSubject: "Help with trip: %{title} (#%{id})",
      contentStart: "We're sorry you're experiencing some difficulties. Please email us at ",
      contentEnd:
        " for assistance. Rest assured, we'll respond during business hours within 2 business days.",
    },
    error:
      "We're currently experiencing some connectivity issues with Navigator, please check back later. Thank you for your patience!",
    you: "You",
    fromCruisen: "from Cruisen",
    userLikedCruise: "%{author} liked a cruise.",
    userLikedCruises: "%{author} liked some cruises.",
  },
  tripEdition: {
    title: "Edit trip",
    edit: "Edit",
  },
  ageGroups: {
    infant: {
      label: "Infant",
      range: "(under 2)",
    },
    child: {
      label: "Child",
      range: "(2-17)",
    },
    adult: {
      label: "Adult",
      range: "(over 18)",
    },
  },
  cabinTypes: {
    inside: "Inside",
    outside: "Outside",
    balcony: "Balcony",
    suite: "Suite",
  },
  cabinBookingCard: {
    deck: "Deck %{deckNo}",
    cabin: "Cabin %{cabinNo}",
    change: "Change",
    totalAmount: "Total amount",
    cabinTotal: "Cabin total",
    checkingCabinAvailability: "Checking cabin availability",
    changeCabin: "Please change your cabin to continue",
    checkBookingDetailsAndTryAgain: "Please check passenger and payment details, and try again",
    booked: "Booked",
    diningOptions: "Dining options",
    chooseDiningOption: "Choose dining option",
    cabinType: "%{cabinType} cabin",
  },
  cabinDetails: {
    roomDetails: "Room Details",
    totalAmount: "Total amount",
  },
  shipDetails: {
    launched: "Launched",
    occupancy: "Occupancy",
  },
  cabinsFiltering: {
    filterCabins: "Filter cabins",
    samePrice: "All cabins on the deck, have the same price: %{price}",
    cabinTypes: "Cabin types",
    errorTitle: "Cabin filtering is currently unavailable",
    errorDescription: "We apologize for the inconvenience. Please try again later.",
    matchingCabins: "%{amount} matching cabins on this deck",
    matchingDecks: "%{amount} decks with suitable cabins",
  },
  deckSelection: {
    selectDeck: "Select a deck",
    from: "From",
    matchingDecks: "Decks matching your filters",
    notMatchingDecks: "Decks not matching your filters",
    soldOut: "Sold out",
  },
  cabinSelectionSummary: {
    cabins: "Cabins",
    changeCabins: "Change cabins to continue",
    checkingCabinAvailability: "Checking cabin availability",
    continueToPayment: "Continue to payment",
    settingUpPayment: "Setting up your payment...",
    fillPaymentDetails: "Payment details required",
    fillDiningOptions: "Dining option required",
    fillContactDetails: "Contact details required",
    fillPassengersInfo: "Sailor information required",
    bookAndPay: "Book & Pay",
    noOptionSelected: "No option selected",
    selectedPaymentMethod: "Selected payment method",
    cabinsUppercased: "CABINS",
    paymentDetailsUppercased: "PAYMENT DETAILS",
  },
  cruiseBooking: {
    roomSelection: "Room Selection",
    cabinType: "Cabin type",
    selectCabin: "Select cabin",
    cabin: "Cabin %{cabinNo}",
    room: "Room",
    pay: "Pay",
    summary: "Summary",
    payment: "Payment",
    selected: "%{amount} selected",
    decks: "Decks",
    cabinBooked: "cabin booked",
    cabinsBooked: "cabins booked",
    loadingCabinsError:
      "We couldn't load cabins for this deck. Try again later or choose different deck.",
    whichGroupBooking: "Which groups are you booking for?",
    bookCruise: "Book cruise",
    bookingLoading: "Booking...",
    findingCabins: "Scanning availability...",
    preparingCabins: "Preparing cabins...",
    lookingForPerfectFit: "Please hang tight this could take a while",
    cabinsNoneFoundYet: "No cabins found yet",
    cabinsFound: "%{amount} cabins found",
    noCabinsAvailable: "No cabins available for this cruise",
    backToCruises: "Back to cruises list",
    noCabinsMatchFilters: "No cabins matching your filters for this deck",
    clearFilters: "Clear filters",
    changeDeck: "Change deck",
    deckImageError: "We couldn't load deck image, please try later.",
    goBackToCruiseDetails: "Go to cruise details",
    loyaltyTokens: {
      useloyaltyTokens: "Use Cruisen Points",
      availablePoints: "%{amount} available",
      applyPoints: "Apply points",
      firstBookingInfo:
        "You can apply up to %{loyaltyTokensBookingCap} Cruisen Points (%{bookingCap}% of %{cruisePrice} before taxes & fees) on your first booking.",
      tripSubtotal: "Trip subtotal",
      tax: "Tax & Fees",
      tripTotal: "Trip total",
      total: "Total",
      loyaltyTokens: "Cruisen Points",
      bookingEarnings: "You will earn %{amount} Cruisen Points for this booking.",
    },
    errors: {
      unknown: "Booking failure. Please contact support",
      basketNotFound: "Booking failure. Please contact support",
      cabinUnavailable: "Cabin no longer available",
      roomHasBookedCabin: "Room already has booked cabin",
    },
  },
  passengerDetailsModal: {
    title: "Title",
    mr: "Mr",
    ms: "Ms",
    mrs: "Mrs",
    miss: "Miss",
    passengerDetails: "Sailor info",
    passengerDetailsWithName: "%{name}'s sailor info",
    matchingProfileFound:
      "We found a matching profile for %{name} and pre-filled the form. Click 'Save' to confirm.",
    primarySailorResidence: "Use my residence",
    enterValidPostcode: "Please enter valid postcode, like 12345",
  },
  fixBookingData: {
    title: "Enter required information",
    provideInformationForChild: "Please provide the date of birth for your children.",
  },
  bookingPassengers: {
    roomInfo: "%{roomName} | Cabin %{cabinNo}",
    addInfo: "Add",
    sailorInfo: "Sailor info",
    contactDetailsUppercased: "CONTACT DETAILS",
    fillContactDetails: "Fill contact details",
  },
  creditCardForm: {
    fillDetails: "Payment Details",
    holder: "Cardholder name",
    cardNumber: "Card number",
    expiry: "Expiry",
    cvcCode: "CVC",
    editDetails: "Edit details",
    addDetails: "Add details",
    addCreditCardDetails: "Add credit card details",
    creditCardDetails: "Credit card details",
    creditCardCVCExpiredNotice: "Please update credit card CVC",
  },
  startSubscriptionModal: {
    title: "Start 30-day trial!",
    description:
      "We are subscription-based now! Thank you for being with us all this time. To continue using Cruisen you can start your free 30-day trial today - no charge until it ends. We'll notify you before billing.",
    visitWebApp: "For more details, please visit the Cruisen web app on desktop.",
  },
  inactiveSubscriptionModal: {
    title: "Your subscription\nis inactive",
    description:
      "We were unable to renew your subscription after multiple attempts. Please update your payment details to continue enjoying full access to Cruisen—we'll process the renewal right away!",
    visitWebApp: "For more details, please visit the Cruisen web app on desktop.",
  },
  pastDueSubscriptionModal: {
    title: "Subscription\nretry pending",
    description:
      "We were unable to renew your subscription this time, but we'll try again %{nextAttempt}. To prevent any interruptions, you can update your payment details now.",
    on: "on %{nextPaymentAttemptDate}",
    soon: "soon",
  },
  profileScreen: {
    profiles: "Traveler profiles",
    primary: "Primary",
    addProfile: "Add profile",
    sailors: "sailors",
    nights: "nights",
    itineraryDetails: "Itinerary details",
    roomType: "Room type",
    primarySailor: "Primary sailor",
    personalInfoPermission: "Your personal information will be used only for booking purposes.",
    countryPicker: {
      searchCountry: "Search a country",
      noCountryLeft: "There are no countries left, please change your search",
    },
    cruiseLinePicker: {
      searchCruiseLine: "Search a cruise line",
      noCruiseLineLeft: "There are no cruise lines left, please change your search",
    },
    loyaltyNumberOptions: {
      title: "Loyalty number options",
      editLoyaltyNumber: "Edit",
      deleteLoyaltyNumber: "Delete",
    },
    statePicker: {
      searchState: "Search a state",
      noStateLeft: "There are no states left, please change your search",
      states: {
        al: { code: "AL", name: "Alabama" },
        ak: { code: "AK", name: "Alaska" },
        az: { code: "AZ", name: "Arizona" },
        ar: { code: "AR", name: "Arkansas" },
        ca: { code: "CA", name: "California" },
        co: { code: "CO", name: "Colorado" },
        ct: { code: "CT", name: "Connecticut" },
        de: { code: "DE", name: "Delaware" },
        dc: { code: "DC", name: "District of Columbia" },
        fl: { code: "FL", name: "Florida" },
        ga: { code: "GA", name: "Georgia" },
        hi: { code: "HI", name: "Hawaii" },
        id: { code: "ID", name: "Idaho" },
        il: { code: "IL", name: "Illinois" },
        in: { code: "IN", name: "Indiana" },
        ia: { code: "IA", name: "Iowa" },
        ks: { code: "KS", name: "Kansas" },
        ky: { code: "KY", name: "Kentucky" },
        la: { code: "LA", name: "Louisiana" },
        me: { code: "ME", name: "Maine" },
        md: { code: "MD", name: "Maryland" },
        ma: { code: "MA", name: "Massachusetts" },
        mi: { code: "MI", name: "Michigan" },
        mn: { code: "MN", name: "Minnesota" },
        ms: { code: "MS", name: "Mississippi" },
        mo: { code: "MO", name: "Missouri" },
        mt: { code: "MT", name: "Montana" },
        ne: { code: "NE", name: "Nebraska" },
        nv: { code: "NV", name: "Nevada" },
        nh: { code: "NH", name: "New Hampshire" },
        nj: { code: "NJ", name: "New Jersey" },
        nm: { code: "NM", name: "New Mexico" },
        ny: { code: "NY", name: "New York" },
        nc: { code: "NC", name: "North Carolina" },
        nd: { code: "ND", name: "North Dakota" },
        oh: { code: "OH", name: "Ohio" },
        ok: { code: "OK", name: "Oklahoma" },
        or: { code: "OR", name: "Oregon" },
        pa: { code: "PA", name: "Pennsylvania" },
        ri: { code: "RI", name: "Rhode Island" },
        sc: { code: "SC", name: "South Carolina" },
        sd: { code: "SD", name: "South Dakota" },
        tn: { code: "TN", name: "Tennessee" },
        tx: { code: "TX", name: "Texas" },
        ut: { code: "UT", name: "Utah" },
        vt: { code: "VT", name: "Vermont" },
        va: { code: "VA", name: "Virginia" },
        wa: { code: "WA", name: "Washington" },
        wv: { code: "WV", name: "West Virginia" },
        wi: { code: "WI", name: "Wisconsin" },
        wy: { code: "WY", name: "Wyoming" },
      },
    },
    form: {
      passengerDetails: "Profile details",
      passengerResidence: "Residence",
      firstName: "First name*",
      lastName: "Last name*",
      dateOfBirth: "Date of birth",
      dateOfBirthRequired: "Date of birth*",
      nationality: "Citizenship",
      passportInfo: "Passport info",
      optional: "(optional)",
      passportNumber: "Passport number",
      passportIssueDate: "Issue date",
      passportExpireDate: "Expire date",
      passportIssuingCountry: "Issuing country",
      address: "Address",
      state: "State",
      postcode: "Zip code",
      country: "Country",
      city: "City",
      submit: "Submit",
      loyaltyNumbers: "Loyalty numbers",
      loyaltyNumber: "Loyalty number",
    },
  },
  paymentRequest: {
    title: "Payment request",
    cabins: "Cabins",
    totalDueDate: "Final due date",
    pricingDetails: "Pricing details",
    paymentMethod: "Payment method",
    bankAccount: "Bank account",
    creditCard: "Credit card",
    acceptTermsAndConditions: "Accept Terms & Conditions",
    termsAndConditions: {
      readAndAgree: "I have read and agree to the",
      modalButton: "Terms & Conditions",
      ofUsingCruisen: "of this quote.",
    },
    cvcNumberExpired: "CVC number has expired on selected card. Please update your card details.",
    fullAmount: {
      title: "Full amount",
      description: "You pay the entire cost of the cruise up front.",
    },
    depositFirst: {
      withAutomatic: {
        title: "Deposit First (with automatic final payment)",
        description:
          "You pay a deposit now, and the remaining balance will be automatically deducted on the final due date.",
      },
      withoutPlan: {
        title: "Deposit only",
        description:
          "You will only pay the deposit, and the remainder of the cruise fare must be paid before the final due date.",
      },
    },
    cardDetails: {
      noCard: "No card available",
      addCard: "Add card",
      endingIn: "%{cardType} ending in %{cardLast4}",
      expDate: "Exp. date %{date}",
      note: "NOTE: Your credit card won’t be charged yet. We will transfer your card details to the advisor, who will handle the payment for the reservation.",
    },
    submit: {
      pay: "Pay %{amount}",
      missingPassengerData: "Sailor information required",
      authorizeAndAccept: "Authorize & accept",
    },
    summary: "Summary",
    paymentDueDate: "Final due date",
    depositAmount: "Deposit amount",
    taxesAndFees: "Taxes & fees",
    cabinPrice: "Cabin fare",
    totalAmount: "Total amount",
    declineQuote: "Decline quote",
  },
  paymentRequestSuccess: {
    quoteApproved: "Quote approved!",
    transactionId: "Transaction ID",
    date: "Date",
    paymentMethod: "Payment method",
    accountNumber: "Account number",
    paymentSchedule: "Payment schedule",
    depositAmount: "Deposit amount",
    taxesAndFees: "Taxes & fees",
    cabinPrice: "Cabin fare",
    totalAmount: "Total amount",
    totalPayment: "Total payment",
    depositPayment: "Deposit first (with no payment plan)",
    paymentStatus: "Payment status",
    total: "Total",
    youPaid: "You paid",
    endingIn: "ending in %{cardLast4}",
    cardNumber: "Card number",
    price: "Price",
    paymentPlan: {
      total: "Total payment",
      totalSplit: "Split total payment",
      depositOnly: "Deposit only",
      depositWithAutoFinalPayment: "Deposit with automatic final payment",
    },
  },
  paymentRequestRoomDetails: {
    totalPaid: "Total paid",
    paymentRequest: 'Quote "%{paymentRequestTitle}"',
    payments: "Payments",
    paidBy: "Paid by %{user}",
    approvedBy: "Approved by %{user}",
    you: "you",
    issuedOn: "Issued on",
    finalDueDate: "Final due date",
    paymentDueDate: "Final due date",
    quoteStatus: "Quote status",
    room: "Room",
  },
  paymentsStatus: {
    ACHProcessing: "Processing",
    ACHFailed: "Failed",
    approved: "Approved",
    succeeded: "Succeeded",
    cancelled: "Cancelled",
    failed: "Failed",
  },
  invalidatePaymentRequests: {
    title: "Invalidate payment requests",
    description:
      "Unselecting this cruise will invalidate all existing payment requests. Your advisor will need to create new payment requests after a different cruise is selected.",
    unselect: "Unselect",
    unselecting: "Unselecting...",
    cancel: "Cancel",
  },
  paymentRequestType: {
    cabinBooking: "Cabin booking",
    other: "Other",
  },
  paymentRequestStatus: {
    approved: "Approved",
    approvedRoom: "Quote approved",
    cancelledByAgent: "Cancelled by agent",
    cancelledByAgentRoom: "Quote cancelled by agent",
    partiallyPaid: "Partially paid",
    partiallyPaidRoom: "Quote partially paid",
    rejectedByUser: "Rejected by user",
    rejectedByUserRoom: "Quote rejected by user",
    requiresPaymentMethod: "Pending",
    requiresPaymentMethodRoom: "Quote pending",
    totalPaid: "Total paid",
    totalPaidRoom: "Quote total paid",
    confirmed: "Confirmed",
    confirmedRoom: "Quote confirmed",
  },
  declinePaymentRequestModal: {
    title: "Decline quote",
    description: "Are you sure you want to decline this quote?",
  },
  paymentPlanStatus: {
    total: "Total payment",
    totalSplit: "Split total payment",
    depositOnly: "Deposit only",
    depositWithAutoFinalPayment: "Deposit with automatic final payment",
  },
  navigatorHeader: {
    allMessages: "All messages",
    all: "All",
    quote: "quotes",
    attachment: "attachments",
    cruise: "cruises",
    reconnecting: "Reconnecting",
  },
  navigatorFilteringModal: {
    messageType: "Message type",
    all: "All",
    quote: "Quote",
    cruise: "Cruise",
    attachment: "Attachment",
  },
  blockAccess: {
    yourAdvisor: "Your advisor",
    letsGetYouConnected: "Let's get you connected!",
    weCouldntFindYourTravelAdvisor:
      "We couldn't find your travel advisor. Please tap the link you used to download the Cruisen again. If you can't find the link - contact your advisor.",
  },
  loyaltyProgram: {
    title: "Cruisen Points",
    totalAvailablePoints: "Total available points",
    pendingPoints: "Pending points",
    history: "History",
    infoModal: {
      title: "What are Cruisen Points?",
      description: "And how do I get them?",
      introduction:
        "Introducing Cruisen Points, our loyalty program designed to reward you for cruising with us! Here’s how you can earn and use your points:",
      earn: "Earn",
      cruisenPoints: "Cruisen Points",
      signUp: "Sign Up: Get %{amount} points just for joining.",
      inviteFriends:
        "Invite Friends: Earn %{amount} points for each friend you invite (up to %{limit} friends).",
      bookCruise:
        "Book a Cruise: Earn %{amount}% points for every dollar spent on commissionable fares.",
      usePoints: "Use your points",
      firstBooking: "First Booking: Redeem up to %{amount}% of the booking total before taxes.",
      subsequentBookings: "Subsequent Bookings: Redeem up to %{amount}% of the booking total.",
      trackPoints: "Track your points in the app and make the most of your Cruisen experience.",
    },
    historyItem: {
      influencerInvitation: "Cruisen registration",
      userJoined: "Cruisen registration",
      userInvitation: "%{invitedUserFirstName} %{invitedUserLastNameInitial}. joined Cruisen",
      booking: "Booking a cabin",
      manualBonus: "Bonus from Cruisen",
    },
  },
  cabinTypesDescriptions: {
    cabinTypesOverview: "Cabin Types Overview",
    inside: "Inside",
    insideDescription:
      "Inside cabins are compact and cost-effective, designed for comfort and utility, ideal for those who prefer to spend their days exploring the ship's amenities. These cabins provide a cozy sanctuary for rest after a day full of activities.",
    outside: "Outside",
    outsideDescription:
      "Outside cabins offer the added benefit of a window or porthole, bringing in natural light and views of the ocean or destinations. This option combines the comfort of standard accommodations with the pleasure of an external view.",
    balcony: "Balcony",
    balconyDescription:
      "Balcony cabins extend your private space to the outdoors, allowing for personal sea views and fresh air from the comfort of your room. They strike a balance between the luxury of space and the enjoyment of your own outdoor area.",
    suite: "Suite",
    suiteDescription:
      "Suites are the pinnacle of cruise accommodation, offering expansive living spaces, enhanced amenities, and often exclusive access to specialized services. They provide an opulent retreat for those seeking the utmost in comfort and exclusivity on their voyage.",
  },
  emptyStateComponent: {
    generic: {
      heading: "So empty... so sad",
      content: "No data found yet. Try clicking the button to refresh or reload the app.",
      button: "Let's try this again",
    },
  },
  agentFunctions: {
    recommendCruise: {
      cruisesFound:
        "I've found some cruises that match your search. Tap the links I sent to view more details.",
      noCruisesFound:
        'Sorry I was unable to find a cruise matching your search. Please try modifying your search and remember to be very specific. You can also go to the "Cruises" tab to manually search and filter for cruises.',
      noParams: "No cruises found: must provide some details about cruise you are looking for.",
    },
    findCruiseLineIds: "Cruise line ids matching search: %{cruiseLineIds}",
    findCruiseShipIds: "Cruise ship ids matching search: %{cruiseShipIds}",
    findCruiseDestinationIds:
      "Destination port ids matching search: %{destinationPortIds}, Destination region ids matching search: %{destinationRegionIds}",
    findCruiseDepartureIds: "Departure port ids matching search: %{departurePortIds}",
    cancelCruise:
      'To cancel a cruise, please contact support by tapping the "Advisor" button and sending a message.',
    getCruiseDetails:
      "Sorry I can not provide more details about specific cruises beyond what is available in the app. Please tap on a cruise card or one of the links that was sent in the chat to view more details.",
    getAppInstructions: "Information from Cruisen Documentation: %{appInstructions}",
  },
  emails: {
    global: {
      emailSignature: "The Cruisen Team",
      unsubscribe: "Unsubscribe",
      footerQuote: "Set sail, together. Cruisen",
      help: "Need help?",
      contact: "Contact Cruisen",
    },
    login: {
      subject: "Sign in to Cruisen",
      title: "Welcome aboard!",
      body: "We received a request to sign in to Cruisen using this email address. Simply tap the login button on the device you installed Cruisen to sign into the app. If you did not request this link, you can safely disregard this email.",
      bodyWeb:
        "We received a request to sign in to Cruisen using this email address. Please copy the confirmation code below and paste it in the app. If you did not request this code, you can safely disregard this email.",
      button: "Login",
      confirmationOce: "Confirmation code",
    },
    booking: {
      subject: "Cruisen booking confirmation",
      title: "Your cruise is confirmed!",
      yourCruisenBookingNumber: "Your Cruisen booking number is ",
      body: "Your trip details",
      guestsTitle: "Sailor details",
      cruisenBookingNumber: "Cruisen booking number",
      cruisenBookingCode: "Cruisen booking code",
      mailingAddress: "Mailing address",
      bookingCruiseLineReservationCode: "Cruise line booking number",
      cabinDetailsTitle: "Ship & cabin details",
      cruiseLine: "Cruise line",
      cruiseShip: "Cruise ship",
      cabinNo: "Cabin number",
      deck: "Deck",
      diningArea: "Dining area",
      itineraryTitle: "Your itinerary",
      paymentDetailsTitle: "Payment details",
      nameOnCard: "Name on card",
      lastFourOnCard: "Last 4 numbers on card",
      cardType: "Card type",
      cabinType: "Cabin type",
      expirationDate: "Expiration date",
      total: "Total",
      button: "Action",
      loyaltyTokens: "Cruisen Points",
      loyaltyTokensEarned: "Cruisen Points earned",
      taxesAndFees: "Taxes & Fees",
    },
    marketing: {
      subject: "New deals from Cruisen",
      title: "Book you vacation today.",
      body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec neque neque, sagittis et semper elementum.",
      button: "Book now",
    },
    serious: {
      subject: "",
      body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec neque neque, sagittis et semper elementum, varius nec mauris.\nPellentesque laoreet lorem massa, vitae suscipit augue ultrices at. Duis mattis massa vitae ante sodales convallis. Pellentesque bibendum quis quam quis bibendum. Maecenas sodales neque in urna fringilla, ac semper dolor cursus.\n Nam finibus, elit vel pretium vulputate, massa mi eleifend velit, at volutpat nunc felis vel libero.\n",
    },
    unreadMessagesReminder: {
      subject: {
        unreadMessages: "You have %{unreadMessagesCount} unread messages",
        unreadMessagesFromUser:
          "Hey %{userFirstName} you have unread messages from %{authorFullName}",
        unreadMessagesFromCruisen: "%{authorFullName} from Cruisen sent you a message",
      },
    },
    paymentRequest: {
      title: 'New quote "%{quoteName}" received',
      body: 'Hi %{userFirstName}👋\nYou\'ve received a new quote for your room from "%{tripName}" trip. You can find details below.',
      paymentDetails: "Payment details",
      totalDueDate: "Final due date",
      deckAndCabin: "Deck · Cabin",
      depositAmount: "Deposit amount",
      subtotal: "Subtotal",
      taxesAndFees: "Taxes and fees",
      total: "Total",
      footer:
        "To confirm your booking, simply click below to complete your payment.\n\nIf you have any questions or need modifications, feel free to contact your advisor.",
      button: "View quote",
    },
  },
  validation: {
    useOnlyEnglishLetters: "Only English letters allowed",
    passportNumberMinLength: "Passport must be at least 5 characters long",
    cannotUseYourOwnPhoneNumber: "You cannot use your own phone number",
  },
  broadcasts: {
    nextMorning: {
      title: "Hello, from Cruisen",
      body: "I'm Reid, the founder of Cruisen. Thanks for downloading our app! Feel free to chat with us any time by tapping \"Advisor\" below, we're here to make your Cruisen booking journey seamless 😊.",
      buttonText: "Chat With Us",
    },
  },
  notifications: {
    welcome: {
      title: "Welcome to Cruisen!",
      body: "%{userFirstName} created a new trip.",
    },
    newAdvisorTrip: {
      title: "%{userFirstName} %{userLastNameInitial}. created a new trip",
      body: 'One of your clients created a new trip "%{tripName}". Tap to view the trip.',
      ctaButtonText: "Open trip",
    },
    advisorInvitedNewUser: {
      title: `%{userFirstName} %{userLastNameInitial}. invited you to trip "%{tripName}"`,
      body: `Hi %{invitedFirstName}! Welcome to Cruisen. Your advisor, %{userFirstName} %{userLastName} with %{agencyName} has invited you to collaborate on your next trip "%{tripName}". Simply reply to this number, and your advisor will get your message. Text STOP to opt out at any time.`,
    },
    advisorInvitedNewUserReminder: {
      title: `%{userFirstName} %{userLastNameInitial}. invited you to trip "%{tripName}"`,
      body: `Hi %{invitedFirstName}! It looks like you haven't yet accepted the invite to collaborate on your next trip "%{tripName}". Tap here to view the invitation, and accept:`,
    },
    advisorInvitedExistingUser: {
      title: `%{userFirstName} %{userLastNameInitial}. invited you to trip "%{tripName}"`,
      body: `Hi %{invitedFirstName}! Your advisor, %{userFirstName} %{userLastName} with %{agencyName} has invited you to collaborate on your next trip "%{tripName}". Tap here to view the invitation:`,
    },
    advisorRemovedUser: {
      title: `%{userFirstName} %{userLastNameInitial}. removed you from trip "%{tripName}"`,
      body: `Hi %{removedFirstName}! Just letting you know that you've been removed from the trip "%{tripName}". Sorry about that, if you think this was a mistake, please contact your advisor, %{userFirstName} %{userLastName} with %{agencyName}.`,
    },
    bookingConfirmation: {
      sms: `It's time to get excited! %{userFirstName} %{userLastNameInitial}. has booked cabin %{bookingCabinNo} on %{cruiseSailingName} for you. Pack your bags, and get ready for a wonderful cruise vacation. Here's the cruise confirmation, which we've also emailed to you: \n\n%{bookingConfirmationFileUrl}`,
    },
    tripCabinsScanFinished: {
      title: "Trip Cabins Scan Finished",
      body: "Cabins scan done for all cruise sailings",
    },
    cruiseCabinsScanFinished: {
      title: "Cruise Cabins Scan Finished",
      body: "%{cruiseSailingName} has %{cabinsAvailable} cabins available starting from %{lowestPrice}",
    },
    tripRoomCreated: {
      title: "%{userFirstName} %{userLastNameInitial}. created %{roomName}",
      body: "%{userFirstName} %{userLastNameInitial}. created %{roomName}. Feel free to join!",
    },
    tripRoomRenamed: {
      title: "%{userFirstName} %{userLastNameInitial}. renamed %{oldRoomName} to %{newRoomName}.",
      body: "%{userFirstName} %{userLastNameInitial}. renamed %{oldRoomName} to %{newRoomName}.",
    },
    userLikedTripSearchResult: {
      title: "%{userFirstName} %{userLastNameInitial}. likes a %{cruiseSailingName}.",
      body: "%{userFirstName} %{userLastNameInitial}. likes a %{cruiseSailingName} cruise sailing %{date} on %{cruiseSailingLineName}.",
    },
    userSetPreferredCruise: {
      title:
        "%{userFirstName} %{userLastNameInitial}. saved %{cruiseSailingName} as the trips cruise.",
      body: "%{userFirstName} %{userLastNameInitial}. saved %{cruiseSailingName} cruise sailing %{date} on %{cruiseSailingLineName} to book later.",
    },
    paymentRequest: {
      title: 'New quote "%{quoteName}" received',
      body: `You've received a quote for a %{cabinGradeName} cabin on the "%{tripName}" trip! Check it out, and submit your approval so your advisor can lock in your vacation.`,
    },
    userApprovedPaymentRequest: {
      title: 'Payment approved for trip "%{tripName}"',
      body: '%{userFirstName} %{userLastNameInitial}. approved payment for quote "%{quoteName}"',
    },
    userApprovedCreditCardForAgent: {
      title: 'Payment approved for trip "%{tripName}"',
      body: '%{userFirstName} %{userLastNameInitial}. approved payment for quote "%{quoteName}"',
      ctaButtonText: "Open trip",
    },
    navigatorCruiseRecommendation: {
      title: "Cruise recommendation from @navigator.",
      body: "Here is a cruise that matches your interests!",
    },
    collaboratorJoinedTrip: {
      title: "New person joined a trip",
      body: "%{userFirstName} %{userLastNameInitial}. joined %{tripName}.",
    },
    guestJoinedTripRoom: {
      title: "Guest joined trip room",
      body: "%{guestFirstName} %{guestLastNameInitial}. joined %{roomName}.",
    },
    guestLeavedTripRoom: {
      title: "Guest left trip room",
      body: "%{guestFirstName} %{guestLastNameInitial}. left %{roomName}.",
    },
    chatMessage: {
      title: "%{sender} sent message to %{tripName}",
    },
    userBookedCabin: {
      title: "Cabin booked for %{tripName}",
      body: "%{userFirstName} %{userLastNameInitial}. booked cabin #%{cabinNo} at %{deckName}",
      bodyGeneric:
        "%{userFirstName} %{userLastNameInitial}. booked guaranteed %{cabinGradeType} cabin",
    },
    savedCruiseCabins: {
      title: "Cabin saved for %{tripName}",
      body: "%{userFirstName} %{userLastNameInitial}. Saved cabin #%{cabinNo} at %{deckName}",
    },
    tripUpdated: {
      title: "Trip updated",
      body: "%{from} made changes to the trip, here is an updated summary 🛳️:",
    },
    tripCreated: {
      title: "Trip created",
      body: "%{from} just created a new trip here is a quick summary 🛳️:",
    },
    loyaltyTokensEarn: {
      influencerInvitation: {
        title: "Cruisen Points earned",
        body: "You earned %{loyaltyTokensEarned} points for signing up!",
      },
      userJoined: {
        title: "Cruisen Points earned",
        body: "You earned %{loyaltyTokensEarned} points for signing up!",
      },
      userInvitation: {
        title: "Cruisen Points earned",
        body: "You earned %{loyaltyTokensEarned} for inviting %{invitedUserFirstName} %{invitedUserLastNameInitial}!",
      },
      booking: {
        title: "New Cruisen Points",
        body: "You will earn %{loyaltyTokensEarned} points after going on the cruise.",
      },
      manualBonus: {
        title: "New Cruisen Points",
        body: "You earned %{loyaltyTokensEarned} points as a bonus.",
      },
    },
    loyaltyTokensUnlocked: {
      title: "Cruisen Points unlocked",
      body: "You have %{loyaltyTokensUnlocked} points now available after your cruise.",
    },
    priceDrop: {
      title: "Cruise price dropped",
      body: '🚨 Price drop alert! A "%{cruiseSailingName}" cruise has dropped in price by %{priceDropPercentage}%! Check out this cruise and %{resultsWithPriceDropCounter} other price drops for your “%{tripName}” trip.',
      ctaButtonText: "Open cruises",
    },
  },
  agentProfile: {
    cruisesOverallVolumePercent: {
      "0-25": "0-25%",
      "25-50": "25-50%",
      "50-75": "50-75%",
      "75-90": "75-90%",
      "90+": "90% or more",
    },
    cruisesAnnualBookingVolume: {
      "0-50k": "$0-50k",
      "50k-100k": "$50k-100k",
      "100k-250k": "$100k-250k",
      "250k-500k": "$250k-500k",
      "500k-1m": "$500k-1m",
      "1m+": "$1m+",
      "not-disclosed": "Prefer not to disclose",
    },
    primaryCustomerAcquisitionMeans: {
      "social-media": "Social Media",
      "word-of-mouth": "Word of Mouth",
      advertising: "Advertising",
      "repeat-business": "Repeat Business",
      other: "Other",
    },
    agencyGoalsAtCruisen: {
      "save-time": "Save time and effort",
      "grow-customers": "Grow my existing customer base",
      "gain-customers": "Help gain new customers",
      "prevent-churn": "Prevent customer ghosting",
    },
  },
  cruiseLineLoyaltyMember: {
    title: "Add a loyalty number",
    cruiseLine: "Cruise line",
    loyaltyNumber: "Loyalty number",
    deleteTitle: "Delete loyalty number",
    deleteDescription: "Are you sure you want to delete this loyalty number?",
  },
  errors: {
    auth: "Oops! We're currently facing issues with authentication.",
    downloadFile: "Failed to download file",
    mobileAppNotSupportingAdvisors:
      "Mobile app is not supporting advisor dashboard yet. Please log in on website.",
    tryAgainLater: "Please try again later or contact support team.",
    updatingAccount: "Oops! We're currently facing issues updating account, please try later.",
    loyaltyProgram: "Oops! We're currently facing issues with Cruisen Points.",
    rooms: "Oops! We're currently facing issues getting rooms.",
    trip: "Oops! We're currently facing issues getting trip.",
    createTrip: "Oops! We're currently facing issues creating trip.",
    updateTrip: "Oops! We're currently facing issues updating trip.",
    tripData: "Oops! We're currently facing issues getting trip data.",
    userTrips: "Oops! We're currently facing issues getting your trips.",
    invitation: "Oops! We're currently facing issues with invitation.",
    navigator: "Oops! We're currently facing issues with Navigator.",
    profile: "Oops! We're currently facing issues with profiles.",
    agentProfile: "Oops! We're currently facing issues with agent profiles.",
    billing: "Oops! We're currently facing issues with billing.",
    booking: "Oops! We're currently facing issues with booking.",
    cruiseLines: "Oops! We're currently facing issues with cruise lines.",
    agencyConsortia: "Oops! We're currently facing issues with consortia.",
    hostAgency: "Oops! We're currently facing issues with host agency.",
    cruiseLineLoyaltyMember:
      "Oops! We're currently facing issues updating cruise line loyalty member.",
    passportNumber: "Oops! We're currently facing issues with passport number.",
  },
}

type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>
    }
  : T

export default en
export type Translations = typeof en
export type PartialTranslations = DeepPartial<typeof en>
